import { Link } from 'react-router-dom';

export default function FeaturedArticle() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            Featured Guide
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Vigorbuy Spreadsheet Complete Guide
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Everything you need to know about using Vigorbuy Spreadsheet for smarter online shopping — from getting started to advanced tips and safety recommendations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {[
            {
              icon: 'ri-book-open-line',
              title: 'Getting Started',
              desc: 'Learn the basics of navigating Vigorbuy Spreadsheet, understanding category organization, and making the most of the platform from day one.',
            },
            {
              icon: 'ri-search-eye-line',
              title: 'Product Discovery',
              desc: 'Master the art of finding exactly what you need across multiple product categories with efficient browsing and comparison techniques.',
            },
            {
              icon: 'ri-shield-check-line',
              title: 'Safety & Best Practices',
              desc: 'Understand how to shop safely using Vigorbuy Spreadsheet, verify product information, and follow recommended guidelines for secure browsing.',
            },
          ].map((card) => (
            <div key={card.title} className="bg-background-100 rounded-xl p-6 md:p-7">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4">
                <i className={`${card.icon} text-accent-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2">{card.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{card.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/vigorbuy-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-xl text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Read The Full Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}